import React, { useContext, useEffect, useState } from "react";

/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";

/// Css
import "./index.css";
// import "./chart.css"; // Removed since chart components are deleted
import "./step.css";

/// Organisation
import CreateOrganisation from "./components/Organisation/CreateOrganisation";
import ListOrganisation from "./components/Organisation/ListOrganisation";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./pages/ScrollToTop";


/// Dashboard
import OrganisationDashboard from "./components/Dashboard/Organisation";
import JobDashboard from "./components/Dashboard/Job";
import ComparisonDashboard from "./components/Dashboard/Comparison";

//Jobs
// import JobLists from "./components/Jobs/JobLists";
// import JobDiscView from "./components/Jobs/JobDiscView";
// import JobHvpView from "./components/Jobs/JobHvpView";
import CreateJob from "./components/Jobs/CreateJob";
// import ThemeCustomization from "./components/Jobs/themeCustomization";
// import AssistantCustomization from "./components/Jobs/assistantCustomization";
import ListJob from "./components/Jobs/ListJob";
import ViewJob from "./components/Jobs/ViewJob";

//Job Activities
import ListJobActivity from "./components/JobActivity/ListJobActivity";

//Employees
import CreateEmployee from "./components/Employees/CreateEmployee";
import ListEmployee from "./components/Employees/ListEmployee";
import ViewEmployee from "./components/Employees/ViewEmployee";
import ListAdmins from "./components/Team/ListAdmins";

//Customers
import CreateCustomer from "./components/Customers/CreateCustomer";
import ListCustomer from "./components/Customers/ListCustomer";
import ViewCustomer from "./components/Customers/ViewCustomer";

/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";

import ProtectedRoute from "./layouts/protectedRoute/protectedRoute";
import ReRoute from "./layouts/protectedRoute/reroutePage";
// import LogoCustomisation from "./components/Jobs/logoCustomisation";
// import CurrencyCustomization from "./components/Jobs/CurrencyCustomization";
// import MotivatorsReport from "./components/Jobs/MotivatorsReport";
// import PersonalityTest from "./components/Jobs/PersonalityTest";
// import GlobalLoader from "./components/AppsMenu/CustomComponents/GlobalLoader";
// import Customization from "./components/Customization";
// import AdminPanel from "./components/Settings/AdminPanel";
// import MobileApp from "./components/Settings/MobileApp";
import CreateCategory from "./components/Categories/CreateCategory";
import ListCategory from "./components/Categories/ListCategory";
import CreateTask from "./components/Tasks/CreateTask";
import ListTask from "./components/Tasks/ListTask";
import ViewTask from "./components/Tasks/ViewTask";
import OrganisationLogo from "./components/Settings/OrganisationLogo";
import TutorialModal from "./components/Tutorial/TutorialModal";

const Markup = () => {
  // const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  const allroutes = [
    /// allroutes
    { url: "*", component: <ReRoute /> },

    {
      url: "dashboard/organisation",
      component: <OrganisationDashboard />,
      role: "ADMIN",
    },
    {
      url: "dashboard/job",
      component: <JobDashboard />,
      role: "ADMIN",
    },
    {
      url: "dashboard/comparison",
      component: <ComparisonDashboard />,
      role: "ADMIN",
    },

    //Categories
    {
      url: "create-category",
      component: <CreateCategory />,
      role: "ADMIN",
    },
    {
      url: "edit-category/:id",
      component: <CreateCategory />,
      role: "ADMIN",
    },
    {
      url: "category-list",
      component: <ListCategory />,
      role: "ADMIN",
    },

    //Jobs
    { url: "job-list", component: <ListJob />, role: "ADMIN" },
    { url: "draft-list", component: <ListJob />, role: "ADMIN" },
    {
      url: "create-job/:jobId",
      component: <CreateJob />,
      role: "ADMIN",
    },
    {
      url: "create-job",
      component: <CreateJob />,
      role: "ADMIN",
    },
    {
      url: "view-job/:jobId",
      component: <ViewJob />,
      role: "ADMIN",
    },
    {
      url: "edit-job/:jobId",
      component: <CreateJob />,
      role: "ADMIN",
    },

    //Job Activities
    {
      url: "job-activity-list",
      component: <ListJobActivity />,
      role: "ADMIN",
    },

    //Employees
    {
      url: "employee-list",
      component: <ListEmployee />,
      role: "ADMIN",
    },
    {
      url: "add-employee",
      component: <CreateEmployee />,
      role: "ADMIN",
    },
    {
      url: "view-employee/:id",
      component: <ViewEmployee />,
      role: "ADMIN",
    },
    {
      url: "edit-employee/:id",
      component: <CreateEmployee />,
      role: "ADMIN",
    },
    {
      url: "admin-list",
      component: <ListAdmins />,
      role: "ADMIN",
    },

    //Customers
    {
      url: "customer-list",
      component: <ListCustomer />,
      role: "ADMIN",
    },
    {
      url: "create-customer",
      component: <CreateCustomer />,
      role: "ADMIN",
    },
    {
      url: "edit-customer/:id",
      component: <CreateCustomer />,
      role: "ADMIN",
    },
    {
      url: "view-customer/:id",
      component: <ViewCustomer />,
      role: "ADMIN",
    },

    // Organisations
    {
      url: "/super-admin/create-organisation",
      component: <CreateOrganisation />,
      role: "SUPERADMIN",
    },
    {
      url: "/super-admin/edit-organisation/:orgId",
      component: <CreateOrganisation />,
      role: "SUPERADMIN",
    },
    {
      url: "/super-admin/list-organisation",
      component: <ListOrganisation />,
      role: "SUPERADMIN",
    },

    // Tasks
    {
      url: "create-task",
      component: <CreateTask />,
      role: "ADMIN",
    },
    {
      url: "edit-task/:id",
      component: <CreateTask />,
      role: "ADMIN",
    },
    {
      url: "view-task/:id",
      component: <ViewTask />,
      role: "ADMIN",
    },
    {
      url: "task-list",
      component: <ListTask />,
      role: "ADMIN",
    },

    // Settings
    {
      url: "settings/organisation-logo",
      component: <OrganisationLogo />,
      role: "ADMIN",
    },
  ];
  //let path = window.location.pathname;
  // path = path.split("/");
  // path = path[path.length - 1];

  // let pagePath = path.split("-").includes("page");
  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />

        {/* <Route element={<ProtectedRoute role={"ADMIN"} />}>
          <Route
            exact
            path={`motivators-report/:testId`}
            element={<MotivatorsReport />}
          />
        </Route> */}
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route key={i} element={<ProtectedRoute role={data.role} />}>
              <Route exact path={`${data.url}`} element={data.component} />
            </Route>
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  const [showTutorial, setShowTutorial] = useState(() => {
    return localStorage.getItem("isFirstLogin") === "true";
  });

  return (
    <>
      <TutorialModal
        isOpen={showTutorial}
        onClose={() => setShowTutorial(false)}
      />
      <div
        id="main-wrapper"
        className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""
          }`}
      >
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <div className="container mx-auto relative">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Markup;
